import { render } from "./OnboardingData.vue?vue&type=template&id=1f132576&scoped=true"
import script from "./OnboardingData.vue?vue&type=script&lang=js"
export * from "./OnboardingData.vue?vue&type=script&lang=js"

import "./OnboardingData.vue?vue&type=style&index=0&id=1f132576&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f132576"]])

export default __exports__